<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="form__title primary--text mb-8">
          DADOS DO TRIBUNAL
        </p>
      </v-col>
      <v-col cols="12" class="pb-6">
          <v-switch
            class="pa-0 ma-0 justify-self-center d-inline-block new-insurance-form__switch"
            v-model="form.ativo"
            inset
            hide-details
            dense
            color="secondary"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ statusSwitch }}
          </p>
        </v-col>
      <v-col cols="12">
        <BaseFormInput
          id-element="nameCourt"
          placeholder="Inserir"
          v-model="court.nome"
          disabled
          label-text="Nome do Tribunal"
        />
      </v-col>
      <v-col cols="12">
        <BaseFormInput
          id-element="nameRegionCourt"
          placeholder="Inserir"
          v-model="form.nome"
          required
          :rules="[requiredInput]"
          label-text="Nome da Vara"
        />
      </v-col>
      <v-col cols="12" md="9" class="pr-md-5">
        <BaseFormInput
          id-element="cityCourt"
          placeholder="Inserir"
          v-model="form.cidade"
          required
          :rules="[requiredInput]"
          label-text="Cidade"
        />
      </v-col>
      <v-col cols="12" md="3">
        <BaseFormInput
          id-element="codeRegionCourt"
          placeholder="Inserir"
          v-model="form.codigo"
          required
          :rules="[requiredLength4]"
          label-text="Código de Referência"
          icon-information
          text-information="Código que identifica a Vara dentro do Tribunal. Formado por 4 caracteres ele compõe também o número do processo."
        />
      </v-col>
    </v-row>
    <v-row class="pb-12 mt-mb-12">
      <v-spacer />
      <v-col cols="12" md="7" xl="6">
        <div
          class="region-court-form__disclaimer yellow d-flex align-center justify-center"
        >
          <p class="primary--text mb-0 font-weight-bold caption">
            * Código de Referência preenchido irá compor parte do número do
            processo judicial.
          </p>
        </div>
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="4" md="3" xl="2" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="pink white--text"
            width="100%"
            @click="previousPage"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" xl="2">
          <BaseButton
            v-html="textButton"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import { requiredInput } from "@/utils/rules.js";
export default {
  data: () => ({
    requiredInput
  }),
  computed: {
    statusSwitch() {
      const status = this.form.ativo ? "Ativo" : "Inativo";
      return `Status: ${status}`;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.form);
    },
    previousPage() {
      this.$emit("previous-page");
    },
    requiredLength4(value) {
      return (
        !value ||
        value.toString().length === 4 ||
        "O código deve ter 4 caracteres"
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    textButton: {
      type: String
    },
    court: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.region-court-form__
  &disclaimer
    border-radius: 4px
    height: 35px
</style>
